module.exports = __webpack_public_path__ + "static/media/ico-default.2cea662b.svg";